import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMasonryModule } from 'ngx-masonry';

// Modules
import { SharedModule } from '../shared/shared.module';

// Components
import { DashboardPageComponent } from './pages/dashboard/dashboard.page.component';

// Pages
import { PanelsComponent } from './components/panels/panels.component';
import { IntroPanelComponent } from './components/intro-panel/intro-panel.component';
import { FaqPanelComponent } from './components/faq-panel/faq-panel.component';
import { EventsPanelComponent } from './components/events-panel/events-panel.component';
import { NewsPanelComponent } from './components/news-panel/news-panel.component';
import { LoginPanelComponent } from './components/login-panel/login-panel.component';
import { SalesDetailsPanelComponent } from './components/sales-details-panel/sales-details.component';
import { PanelSelectorComponent } from './components/panel-selector/panel-selector.component';
import { NewsCardComponent } from './components/news-card/news-card.component';
import { EventCardComponent } from './components/event-card/event-card.component';
import { ImageFeedComponent } from './components/image-feed/image-feed.component';
import { ImageDetailsModalComponent } from './modals/image-details/image-details.modal.component';
import { SupportRequestModalComponent } from './modals/support-request/support-request.modal.component';
import { TeamsTrainingVideosModalComponent } from './modals/teams-training-videos/teams-training-videos.modal.component';
import { HomePageInstructionsModalComponent } from './modals/homepage-instructions/homepage-instructions.modal.component';
import { NewsDetailsModalComponent } from './modals/news-details/news-details.modal.component';
import { WillnerPageComponent } from './pages/willner/willner.page.component';

/**
 *
 * */
@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgxMasonryModule,

    SharedModule
  ],
  declarations: [
    PanelsComponent,

    IntroPanelComponent,
    LoginPanelComponent,
    SalesDetailsPanelComponent,
    FaqPanelComponent,
    EventsPanelComponent,
    NewsPanelComponent,

    NewsCardComponent,
    EventCardComponent,

    PanelSelectorComponent,
    ImageFeedComponent,

    ImageDetailsModalComponent,
    SupportRequestModalComponent,
    TeamsTrainingVideosModalComponent,
    HomePageInstructionsModalComponent,
    NewsDetailsModalComponent,

    DashboardPageComponent,
    WillnerPageComponent
  ],
  entryComponents: [
    ImageDetailsModalComponent,
    SupportRequestModalComponent,
    TeamsTrainingVideosModalComponent,
    HomePageInstructionsModalComponent,
    NewsDetailsModalComponent
  ],
  exports: [
    PanelsComponent,
    DashboardPageComponent,
    WillnerPageComponent
  ]
})
export class DashboardModule {
}
